var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 168,
    viewBox: "0 0 169 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 147C119.294 147 147.5 118.794 147.5 84C147.5 49.2061 119.294 21 84.5 21C49.7061 21 21.5 49.2061 21.5 84C21.5 118.794 49.7061 147 84.5 147Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_21202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.25 51.75L116.75 116.25",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 105.5H66.5832C57.2737 105.5 49.7236 98.2796 49.7236 89.375C49.7236 80.4704 57.2737 73.25 66.5832 73.25C66.9845 71.4583 67.6761 69.7634 68.6185 68.2047M76.122 61.2243C77.301 60.6008 78.5587 60.0813 79.8846 59.6835C86.6929 57.6195 94.2071 58.9883 99.5929 63.2668C104.979 67.5382 107.422 74.0778 106 80.4167H109.583C112.172 80.417 114.697 81.2183 116.812 82.7105C118.927 84.2027 120.528 86.3127 121.396 88.7512C122.265 91.1897 122.357 93.8371 121.661 96.3302C120.965 98.8233 119.515 101.04 117.51 102.676",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_21202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white",
    transform: "translate(41.5 41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.eed8f196a1973d4166c61c240eee6b30.svg";
export { ForwardRef as ReactComponent };